import { auth } from "../firebase/firebaseConfig";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  sendEmailVerification,
  sendPasswordResetEmail,
} from "firebase/auth";
import { db } from "../firebase/firebaseConfig";
import { doc, getDoc, setDoc } from "firebase/firestore";

export const authService = {
  // ── Connexion + vérifications métier ─────────────────────
  getUserProfile: async (uid) => {
    const snap = await getDoc(doc(db, "users", uid));
    return snap.exists() ? snap.data() : null;
  },

  login: async (email, password) => {
    if (!email || !password)
      throw new Error("Email et mot de passe requis.");

    const cred = await signInWithEmailAndPassword(auth, email, password);
    const user = cred.user;

    if (!user.emailVerified)
      throw new Error("Veuillez vérifier votre email avant de vous connecter.");

    const role = await authService.getUserRole(user.uid);
    return { user, role };
  },

  // ── Inscription + sauvegarde Firestore ──────────────────
  register: async (email, password, firstName, lastName) => {
    if (!email || !password || !firstName || !lastName)
      throw new Error("Tous les champs sont requis.");
    if (password.length < 6)
      throw new Error("Mot de passe trop court (min. 6 caractères).");


    const cred = await createUserWithEmailAndPassword(auth, email, password);
    const user = cred.user;

    await sendEmailVerification(user);

    await setDoc(doc(db, "users", user.uid), {
      email,
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      displayName: `${firstName.trim()} ${lastName.trim()}`,
      role: "client",
      createdAt: new Date(),
    });

    return { user };
  },

  // ── Déconnexion ─────────────────────────────────────────
  logout: () => signOut(auth),

  // ── Reset mot de passe ──────────────────────────────────
  resetPassword: (email) => sendPasswordResetEmail(auth, email),

  // ── Écouter les changements d'auth ──────────────────────
  onAuthChange: (callback) => onAuthStateChanged(auth, callback),

  // ── Récupérer le rôle depuis Firestore ──────────────────
  getUserRole: async (uid) => {
    const snap = await getDoc(doc(db, "users", uid));
    return snap.exists() ? snap.data().role : "client";
  },
};
